import { call, put, select, takeLatest } from 'redux-saga/effects'
import { BillingConstants } from '../../billing/store/billing.constants'
import { IPcr } from '../../pcr/store/pcr.types'
import { setPcsInformation } from '../store/pcsInformation.actions'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import { getPcrIdSelector } from '../../home/selectors'
import { setPaymentInformation } from '../../paymentInformation/store/paymentInformation.actions'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { getServiceIdSelector } from '../../user/selectors'

export function* getPcsInformation(pcrDoc: IPcr) {
  const pcsInformationData = pcrDoc.billing?.pcsInformation
  if (pcsInformationData && Object.keys(pcsInformationData).length !== 0) {
    yield put(setPcsInformation(pcsInformationData))
  }
}

export function* preloadPCR() {
  const pcrID: string = yield select(getPcrIdSelector)
  const serviceId: string = yield select(getServiceIdSelector)
  if (!pcrID) return

  try {
    const pcrDocsService = new PcrDocsService(serviceId)
    const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
    yield call(setPaymentInformation, pcrDoc)
  } catch (e) {
    yield put(throwPcrException(`preloadPCR() error in getPcsInformation.saga.ts: ${e}`))
  }
}

export function* getPcsInformationSaga() {
  yield takeLatest([BillingConstants.REFRESH_BILLING_DATA], performWithMutexHOG, preloadPCR)
}
